import { Globe2, MessageCircle, Unlink } from 'lucide-react'

const normalize = value => String(value || '')
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .toLowerCase()
  .trim()

export function getLeadOrigin(value, attribution = {}) {
  const source = normalize(value)
  const medium = normalize(attribution.utm_medium)
  const paid = attribution.gclid || attribution.gbraid || attribution.wbraid || attribution.fbclid || ['cpc', 'ppc', 'paid', 'paid_social', 'google_ads', 'adwords'].some(term => medium.includes(term))

  if (!source) return { key: 'untracked', label: 'Não rastreada', Icon: Unlink }
  if (source.includes('meta') || source.includes('facebook') || source.includes('instagram')) {
    return paid
      ? { key: 'meta', label: 'Meta Ads', image: '/origins/meta-ads.png' }
      : { key: 'social', label: 'Redes sociais', Icon: Globe2 }
  }
  if (source.includes('chatgpt') || source.includes('openai') || source.includes('gpt')) {
    return { key: 'chatgpt', label: 'ChatGPT', image: '/origins/chatgpt.png' }
  }
  if (['perplexity', 'claude', 'gemini'].some(term => source.includes(term))) {
    return { key: 'ai', label: 'Inteligência artificial', Icon: Globe2 }
  }
  if (source.includes('google')) {
    return paid || source.includes('ads') || source.includes('adwords')
      ? { key: 'google-ads', label: 'Google Ads', image: '/origins/google-ads.png' }
      : { key: 'google-search', label: 'Pesquisa Google', image: '/origins/google-search.png' }
  }
  if (source.includes('bing') || medium.includes('organic')) return { key: 'organic-search', label: 'Pesquisa orgânica', Icon: Globe2 }
  if (['linkedin', 'tiktok', 'twitter', 'x.com'].some(term => source.includes(term)) || medium.includes('social')) return { key: 'social', label: 'Redes sociais', Icon: Globe2 }
  if (medium.includes('referral')) return { key: 'referral', label: 'Site de referência', Icon: Globe2 }
  if (source === 'whatsapp') return { key: 'whatsapp', label: 'WhatsApp', Icon: MessageCircle }
  return { key: 'other', label: value || 'Outra origem', Icon: Globe2 }
}

export default function OriginBadge({ source, attribution, iconOnly = false, className = '' }) {
  const origin = getLeadOrigin(source, attribution)
  const Icon = origin.Icon
  return <span className={`lead-origin-badge ${origin.key} ${iconOnly ? 'icon-only' : ''} ${className}`.trim()} title={origin.label}>
    <span className="lead-origin-icon" aria-hidden="true">
      {origin.image ? <img src={origin.image} alt="" /> : <Icon />}
    </span>
    {!iconOnly && <span>{origin.label}</span>}
  </span>
}
